(() => {
  const swipeMediaQuery = window.matchMedia("(max-width: 749px)");
  const swipeThreshold = 60;
  const verticalThreshold = 40;

  let touchStartX = null;
  let touchStartY = null;

  function isTypingTarget(target) {
    if (!target) return false;
    const tagName = target.tagName;
    return (
      target.isContentEditable ||
      tagName === "INPUT" ||
      tagName === "TEXTAREA" ||
      tagName === "SELECT"
    );
  }

  function getVisiblePagination() {
    return Array.from(document.querySelectorAll("[data-pagination-enhanced]")).find(
      (element) => !element.closest(".js-hidden"),
    );
  }

  function navigateToPage(direction) {
    const pagination = getVisiblePagination();
    if (!pagination) return;

    const attributeName = direction === "next" ? "data-next-url" : "data-prev-url";
    const destination = pagination.getAttribute(attributeName);
    if (!destination) return;

    window.location.href = destination;
  }

  document.addEventListener("keydown", (event) => {
    if (isTypingTarget(event.target) || event.altKey || event.ctrlKey || event.metaKey) return;

    if (event.key === "ArrowRight") {
      navigateToPage("next");
    } else if (event.key === "ArrowLeft") {
      navigateToPage("prev");
    }
  });

  document.addEventListener(
    "touchstart",
    (event) => {
      if (!swipeMediaQuery.matches || event.touches.length !== 1) return;

      const pagination = getVisiblePagination();
      if (!pagination || !pagination.contains(event.target) || isTypingTarget(event.target)) return;

      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    },
    { passive: true },
  );

  document.addEventListener(
    "touchend",
    (event) => {
      if (touchStartX === null || touchStartY === null) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      touchStartX = null;
      touchStartY = null;

      if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaY) > verticalThreshold) return;

      if (deltaX < 0) {
        navigateToPage("next");
      } else {
        navigateToPage("prev");
      }
    },
    { passive: true },
  );
})();
